'use client'

// src/constants/pagination.ts
var DEFAULT_PAGINATION = 10;

export {
  DEFAULT_PAGINATION
};
//# sourceMappingURL=chunk-EVAX4C7B.mjs.map